import RelatedData from './RelatedData';

export default RelatedData;
